import { createApi } from "@reduxjs/toolkit/query/react";

import { createAuthBaseQuery } from "../../common/utils";
import { HOSTNAME } from "../../constant/host";

export const mileageApi = createApi({
  reducerPath: "mileageApi",
  // 認証・CSRF・act-as ヘッダー付きの共通 baseQuery（デモガード込み）
  baseQuery: createAuthBaseQuery(HOSTNAME),
  tagTypes: ["MileageStatus"],
  endpoints: (builder) => ({
    getMileageStatus: builder.query({
      query: () => ({
        url: "/api/me/mileage-status",
        method: "GET",
      }),
      providesTags: ["MileageStatus"],
    }),
    updateMileageProgress: builder.mutation({
      query: (progressData) => ({
        url: "/api/me/mileage-status",
        method: "PATCH",
        body: progressData,
      }),
      invalidatesTags: ["MileageStatus"],
    }),
  }),
});

// RTK Query で生成されたフックをエクスポート
export const { 
  useGetMileageStatusQuery, 
  useUpdateMileageProgressMutation 
} = mileageApi; 